module.exports = __webpack_public_path__ + "sip.png?f1f5e89d3faf8ebc1c46ca1e46b833c7";


//////////////////
// WEBPACK FOOTER
// ./src/assets/sip.png
// module id = 248
// module chunks = 0